import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({

  // Checks

  'check.form.autocomplete': {
    defaultMessage: 'Add a checklist',
    id: 'check.form.autocomplete'
  },
  'check.form.heading': {
    defaultMessage: 'Checklists',
    id: 'check.form.heading'
  },
  'check.table.header.name': {
    defaultMessage: 'Checklist Name',
    id: 'check.table.header.name'
  },
  'check.table.header.snapshot': {
    defaultMessage: 'Library Version',
    id: 'check.table.header.snapshot'
  },
  'check.table.header.version': {
    defaultMessage: 'Latest Version',
    id: 'check.table.header.version'
  },
  'check.table.item.hint.hasupdate': {
    defaultMessage: 'A newer version of this checklist is available',
    id: 'check.table.item.hint.hasupdate'
  },
  'check.table.item.remove': {
    defaultMessage: 'Remove this checklist',
    id: 'check.table.item.remove'
  },
  'check.table.item.status.saved': {
    defaultMessage: 'All changes saved to the library',
    id: 'check.table.item.status.saved'
  },
  'check.table.item.status.unsaved': {
    defaultMessage: 'Changes to this checklist have not yet been saved to the library',
    id: 'check.table.item.status.unsaved'
  },
  'check.table.item.version.revert': {
    defaultMessage: 'Restore this checklist to its saved version',
    id: 'check.table.item.version.revert'
  },
  'check.table.item.version.update': {
    defaultMessage: 'Update this checklist to its latest version',
    id: 'check.table.item.version.update'
  },
  'check.table.label': {
    defaultMessage: 'A table of checklists selected for inclusion in the library',
    id: 'check.table.label'
  },
  'check.table.previousitem': {
    defaultMessage: 'Move this check to the previous version',
    id: 'check.table.previousitem'
  },
  'check.table.removeitem': {
    defaultMessage: 'Remove this check',
    id: 'check.table.removeitem'
  },
  'check.table.unsavedchanges': {
    defaultMessage: 'Unsaved check',
    id: 'check.table.unsavedchanges'
  },
  'check.table.updateitem': {
    defaultMessage: 'Update this check to the latest version',
    id: 'check.table.updateitem'
  },

  // Library

  'library.form.confirm.description': {
    defaultMessage: 'Once saved, you will not be able to remove any added checklists.',
    id: 'library.form.confirm.description'
  },
  'library.form.confirm.title': {
    defaultMessage: 'Save library changes?',
    id: 'library.form.confirm.title'
  },
  'library.form.description': {
    defaultMessage: 'Description',
    id: 'library.form.description'
  },
  'library.form.heading': {
    defaultMessage: 'Library',
    id: 'library.form.heading'
  },
  'library.form.name': {
    defaultMessage: 'Name',
    id: 'library.form.name'
  },

  // Rules

  'rule.form.heading': {
    defaultMessage: 'Rules',
    id: 'rule.form.heading'
  },
  'rule.table.header.name': {
    defaultMessage: 'Rule Name',
    id: 'rule.table.header.name'
  },
  'rule.table.label': {
    defaultMessage: 'A table of rules selected for inclusion in the library',
    id: 'rule.table.label'
  },
  'rule.table.removeitem': {
    defaultMessage: 'Remove this rule',
    id: 'rule.table.removeitem'
  },

  // Schedules

  'schedule.form.heading': {
    defaultMessage: 'Schedules',
    id: 'schedule.form.heading'
  },
  'schedule.table.header.name': {
    defaultMessage: 'Schedule Name',
    id: 'schedule.table.header.name'
  },
  'schedule.table.label': {
    defaultMessage: 'A table of schedules selected for inclusion in the library',
    id: 'schedule.table.label'
  },
  'schedule.table.removeitem': {
    defaultMessage: 'Remove this schedule',
    id: 'schedule.table.removeitem'
  }

});
